import React, { FC, useCallback } from 'react';

interface IOptions {
  imageHeight?: number;
  currentSlideImgSrc?: string;
  ltSideCls?: string;
  rtSideCls?: string;
}

interface IProps {
  hasLtSide?: boolean;
  hasRtSide?: boolean;
  hasMiddleBody?: boolean;
  options: IOptions;
}

const PresenterMobileSideStrip: FC<IProps> = ({ hasLtSide, hasRtSide, hasMiddleBody, options }) => {
  const { imageHeight, currentSlideImgSrc, ltSideCls, rtSideCls } = options;

  const stripRef = useCallback(node => {
    if (node !== null) {
      node.style.height = `${imageHeight}px`;
      node.style.backgroundImage = `url(${currentSlideImgSrc})`;
    }
  }, [imageHeight, currentSlideImgSrc]);

  return (
    <>
      {hasLtSide && (
        <div className={`mobile-side-strip ${ltSideCls}`}>
          <div className="mobile-side-strip__img" ref={stripRef}/>
          {hasMiddleBody && (
            <>
              <div className="mobile-side-strip__middle-area"/>
              <div className="mobile-side-strip__middle-corner"/>
            </>
          )}
        </div>
      )}
      {hasRtSide && <div className={`mobile-side-strip ${rtSideCls}`}/>}
    </>
  );
};

export default PresenterMobileSideStrip;
